class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.loadCartRecommendations === 'function') {
      cartDrawer.loadCartRecommendations();
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  loadCartRecommendations() {
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart.items.length) return;
      const productId = cart.items[0].product_id;

      const url = `/recommendations/products?section_id=cart-drawer-recommendations&product_id=${productId}&limit=6`;

      fetch(url)
        .then(res => res.text())
        .then(html => {
          const container = document.querySelector('#cart-recommendation-section');
          if (container) {
            container.innerHTML = html;
 
            // Re-init Swiper
            requestAnimationFrame(() => {
              setTimeout(() => {
                const existingSwiper = document.querySelector('.cart-related-slider.swiper-initialized');
                if (!existingSwiper) {
                  new Swiper('.cart-related-slider', {
                    slidesPerView: 2.2,
                    loop: false,
                    spaceBetween: 10,
                    initialSlide: 0,
                    navigation: {
                      nextEl: '.cart-related-next',
                      prevEl: '.cart-related-prev',
                    },
                   
                  });
                }
              }, 100);
            });

            // Re-bind Add to Cart buttons
            bindAjaxAddToCartButtons();
          }
        });
    });
  } 
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function bindAjaxAddToCartButtons() {
  document.querySelectorAll('a.ajax-add-to-cart-button').forEach(button => {
    if (button.classList.contains('bound')) return;
    button.classList.add('bound');

    button.addEventListener('click', function (e) {
      e.preventDefault();

      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      })
        .then(res => res.json())
        .then(() => {
          // Fetch updated cart-drawer and recommendations
          return fetch('/?sections=cart-drawer,cart-drawer-recommendations');
        })
        .then(res => res.json())
        .then((sections) => {
          const parser = new DOMParser();

          // Update cart drawer content
          const newDrawerHtml = parser.parseFromString(sections['cart-drawer'], 'text/html');
          const newDrawer = newDrawerHtml.querySelector('#CartDrawer');
          const currentDrawer = document.querySelector('#CartDrawer');

          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }

          // Update recommendations
          const newRecsHtml = parser.parseFromString(sections['cart-drawer-recommendations'], 'text/html');
          const newRecs = newRecsHtml.querySelector('#shopify-section-cart-drawer-recommendations');
          const existingRecs = document.querySelector('#shopify-section-cart-drawer-recommendations');

          if (newRecs && existingRecs) {
            existingRecs.innerHTML = newRecs.innerHTML;
          } else if (newRecs) {
            const target = document.querySelector('#cart-recommendation-section');
            if (target) target.appendChild(newRecs);
          }

          // Re-open cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        })
        .catch((error) => {
          console.error('Add to cart error:', error);
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', bindAjaxAddToCartButtons);